import { useState } from 'react';

export function shuffleArr(a) {
  var arr: Array<any> = [].concat(a);
  for (let i: number = arr.length - 1; i > 0; i--) {
    // Escaping Array Index Mismatching
    while (a[i] == arr[i]) {
      const j: number = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
  }
  return arr;
}

export function randomPointInRect({ x, y, width, height }) {
  return {
    x: x + Math.random() * width,
    y: y + Math.random() * height,
  };
}

export function useDebounce(func, delay) {
  const [timer, setTimer] = useState(null);
  return (...args) => {
    clearTimeout(timer);
    let _temp = setTimeout(() => {
      func(...args);
    }, delay);
    setTimer(_temp);
  };
}
export function throttle(func, limit) {
  let inThrottle;
  return function (...args) {
    if (!inThrottle) {
      func(...args);
      inThrottle = true;
      setTimeout(() => {
        inThrottle = false;
      }, limit);
    }
  };
}
